import { Seo } from "../components/seo/Seo";
import { Breadcrumbs } from "../components/seo/Breadcrumbs";

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "@id": "https://makershub.be/contact#contactpage",
  url: "https://makershub.be/contact",
  name: "Contact Makers Hub",
  description:
    "Neem contact op met Makers Hub voor workshops, partnerships of vragen over het concept.",
  about: {
    "@type": "Organization",
    name: "Makers Hub",
    email: "hallo.contact@makershub.be",
    url: "https://makershub.be/",
  },
};

export function ContactPage() {
  return (
    <>
      <Seo
        title="Contact — Makers Hub | hallo.contact@makershub.be"
        description="Mail Makers Hub voor workshop-info, partnerships of vragen over onze tech-workshops voor kinderen 10-12. Reactie binnen twee werkdagen."
        path="/contact"
        schema={SCHEMA}
      />
      <article className="page page-contact">
        <div className="container">
          <Breadcrumbs
            items={[
              { label: "Home", to: "/" },
              { label: "Contact" },
            ]}
          />

          <header className="page-hero">
            <span className="section-tag">Contact</span>
            <h1>We horen graag van je</h1>
            <p className="lead">
              Vraag over een workshop, partner-aanbod, of gewoon nieuwsgierig naar wat we doen?
              Stuur een mailtje, we reageren binnen twee werkdagen.
            </p>
          </header>

          <section className="contact-grid">
            <div className="contact-card">
              <h2>Email</h2>
              <p>
                <a href="mailto:hallo.contact@makershub.be">hallo.contact@makershub.be</a>
              </p>
              <p className="muted">
                Voor inschrijvingen, vragen, partner-pitches of media. Antwoord binnen twee
                werkdagen.
              </p>
            </div>

            <div className="contact-card">
              <h2>Locatie</h2>
              <p>Vlaanderen, België</p>
              <p className="muted">
                Workshops vinden plaats in een gehuurd klaslokaal in een school in de regio.
                Exact adres ontvang je bij bevestiging van je inschrijving.
              </p>
            </div>

            <div className="contact-card">
              <h2>Social</h2>
              <p>
                <a
                  href="https://www.facebook.com/profile.php?id=61570829679229"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </p>
              <p>
                <a
                  href="https://www.linkedin.com/in/tuurvanholen/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn (Tuur)
                </a>
              </p>
            </div>

            <div className="contact-card">
              <h2>Inschrijven</h2>
              <p>Inschrijven loopt via het formulier op de homepage.</p>
              <a href="/#inschrijven" className="btn btn-primary">
                Naar inschrijfformulier →
              </a>
            </div>
          </section>
        </div>
      </article>
    </>
  );
}
